<template>
<div class="ctn">
  <div>
    <h4>原始记录</h4>
    {{sshKnownHost.Raw}}
  </div>

  <el-divider v-if="sshKnownHost.Marker" />
  <div v-if="sshKnownHost.Marker">
    <h4>Marker</h4>
    {{sshKnownHost.Marker}}
  </div>

  <el-divider />
  <div>
    <h4>主机列表</h4>
    <span v-for="host in sshKnownHost.Hosts" :key="host.id"><el-tag class="host">{{host}}</el-tag></span>
  </div>

  <el-divider />
  <div>
    <h4>SSH Authorized Key</h4>
    {{sshKnownHost.SshAuthorizedKey}}
  </div>

  <el-divider />
  <div>
    <h4>MD5 指纹</h4>
    {{sshKnownHost.FingerprintLegacyMD5}}
  </div>

  <el-divider />
  <div>
    <h4>SHA256 指纹</h4>
    {{sshKnownHost.FingerprintSHA256}}
  </div>
</div>
</template>

<script>
import model from "../../model"
export default {
  name: "sshKnownHostDetails",
  props: {
    sshKnownHost: model.SshKnownHost,
  },
}
</script>

<style scoped>
.ctn {
  text-align: left;
}
.host {
  margin: 4px;
}
</style>
